import { usePlatformGetPlatform } from "@/api/orval/platform/platform";
import { useGetUserInfo } from "@/api/orval/user/user";

import { useIsAnonymousBrowsing } from "@/modules/anonymousBrowsing";

import { LoyaltyUpgradeCelebration } from "./LoyaltyUpgradeCelebration";
import { useLoyaltyStatus } from "./useLoyaltyStatus";

/**
 * Celebrates a tier the patient earned while away (a visit staff recorded, a recalculation),
 * when they next open the app on Home.
 */
export const PendingLoyaltyCelebration = () => {
  const isAnonymousBrowsing = useIsAnonymousBrowsing();
  const { data: platform } = usePlatformGetPlatform();
  const { data: user } = useGetUserInfo();
  const status = useLoyaltyStatus({
    programEnabled: platform?.platformSettings?.loyaltyProgramEnabled === true,
    isSignedInPatient: !!user && !user.isGuest && !isAnonymousBrowsing,
  });

  return status ? <LoyaltyUpgradeCelebration status={status} /> : null;
};
